import { Subscription } from 'rxjs';

/**
 * Helpful utility functions to manage subscriptions on a component.
 */
export class SubsManager {
  private _initialRandomKeyIndex = Number.MIN_SAFE_INTEGER;
  private _isDestroyed = false;

  /** returns true if onDestroy has been called. */
  get isDestroyed() {
    return this._isDestroyed;
  }

  /** Adds a new subscription without a key.  Behaves like += C# */
  set addSub(subscription: Subscription) {
    const key = (this._initialRandomKeyIndex++).toString();
    this.subs[key] = subscription;
  }

  /** set subs here or use newSub to add a keyless subscription if you don't need to refer to it later. */
  subs: { [key: string]: Subscription } = {};

  /** unsubscribes a subscription with matching key or cancels the subscription itself */
  cancel(keyOrSubscription: string | Subscription) {
    const sub = (typeof keyOrSubscription === 'string') ? this.subs[keyOrSubscription] : keyOrSubscription;
    if (sub && !sub.closed) {
      sub.unsubscribe();
    }
  }

  /** Call from a component's ngOnDestroy method.  Unsubscribes from all subscriptions. */
  onDestroy() {
    if (!this.isDestroyed) {
      Object.keys(this.subs).forEach(x => this.subs[x].unsubscribe());
      this._isDestroyed = true;
    }
  }

}
